import type { ReactNode } from 'react';
import styles from './StatTile.module.css';

export type StatTileTrend = 'up' | 'down' | 'flat';

export type StatTileProps = {
  /** Cevrilmis baslik. Modul seviyesinde sabit tutuyorsan `labelKey` sakla, burada t() ile ver. */
  label: ReactNode;
  /** Deger — sayi ise <MoneyText> gecirmek tercih edilir. */
  value: ReactNode;
  hint?: ReactNode;
  icon?: ReactNode;
  trend?: StatTileTrend;
  className?: string;
};

export function StatTile({ label, value, hint, icon, trend, className }: StatTileProps) {
  return (
    <div className={[styles.tile, className].filter(Boolean).join(' ')}>
      <div className={styles.head}>
        <span className={styles.label}>{label}</span>
        {icon ? <span className={styles.icon}>{icon}</span> : null}
      </div>
      <div className={[styles.value, trend ? styles[trend] : undefined].filter(Boolean).join(' ')}>
        {value}
      </div>
      {hint ? <div className={styles.hint}>{hint}</div> : null}
    </div>
  );
}
